import script from "./team.vue?vue&type=script&setup=true&lang=js"
export * from "./team.vue?vue&type=script&setup=true&lang=js"

import "./team.vue?vue&type=style&index=0&id=5a95567a&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a95567a"]])

export default __exports__